;(function($, undefined){

    var rnn = window.rnn,
        noButtons = document.createElement('button').type === 'button';

    function initPolyfills(){
        if(noButtons){
            $(document).on('click','form button[type="submit"]', function(event){
                event.preventDefault();
                $(this).closest('form').submit();
            }).on('keypress','form input', function(event){
                if(event.which === 13){
                    $(this).closest('form').submit();
                }
            });
        }

        // IE9-10 https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#Polyfill
        if (window.NodeList && !NodeList.prototype.forEach) {
          NodeList.prototype.forEach = Array.prototype.forEach;
        }

        //We may want to use https://github.com/kriskowal/es5-shim , but here is my attempt.
        //ES5 Object.Create Shim for UGC v2
        if (typeof Object.create != 'function') {
          (function () {
            var F = function () {};
            Object.create = function (o) {
              if (arguments.length > 1) { throw Error('Second argument not supported (This browser has no ES5 javascript engine)');}
              if (o === null) { throw Error('Cannot set a null [[Prototype]] (This browser has no ES5 javascript engine)');}
              if (typeof o != 'object') { throw TypeError('Argument must be an object (This browser has no ES5 javascript engine)');}
              F.prototype = o;
              return new F;
            };
          })();
        }

        // polyfill for the trim function
        if (typeof String.prototype.trim !== 'function') {
            String.prototype.trim = function() {
                return this.replace(/^\s+|\s+$/g, '');
            };
        }


        // polyfill for .every (used in restrictions.js:60)
        if (!Array.prototype.every) {
          Array.prototype.every = function (callbackfn, thisArg) {
            "use strict";
            var T, k;

            if (this == null) {
              throw new TypeError("this is null or not defined");
            }

            // 1. Let O be the result of calling ToObject passing the this
            //    value as the argument.
            var O = Object(this);

            // 2. Let lenValue be the result of calling the Get internal method of O with the argument "length".
            // 3. Let len be ToUint32(lenValue).
            var len = O.length >>> 0;

            // 4. If IsCallable(callbackfn) is false, throw a TypeError exception.
            if (typeof callbackfn !== "function") {
              throw new TypeError();
            }

            // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
            if (arguments.length > 1) {
              T = thisArg;
            }

            // 6. Let k be 0.
            k = 0;

            // 7. Repeat, while k < len
            while (k < len) {

              var kValue;

              // a. Let Pk be ToString(k).
              //   This is implicit for LHS operands of the in operator
              // b. Let kPresent be the result of calling the HasProperty internal
              //    method of O with argument Pk.
              //   This step can be combined with c
              // c. If kPresent is true, then
              if (k in O) {

                // i. Let kValue be the result of calling the Get internal method of O with argument Pk.
                kValue = O[k];

                // ii. Let testResult be the result of calling the Call internal method
                //     of callbackfn with T as the this value and argument list
                //     containing kValue, k, and O.
                var testResult = callbackfn.call(T, kValue, k, O);

                // iii. If ToBoolean(testResult) is false, return false.
                if (!testResult) {
                  return false;
                }
              }
              k++;
            }
            return true;
          };
        }
    }

    rnn.modules.register("polyfills", {
        init: initPolyfills
    });

})(jQuery);
